import { css } from '@linaria/core'
import { styled } from '@linaria/react'
import React, { type FC } from 'react'
import type { VoteSubmitDto } from '../types/generated'
import { Typography } from '../ui/Typography'
import { formatTon } from '../utils/formatTon'
import {
  getColorByStatus,
  getVoteStatusFlags,
} from './VoteOptionWithMeta.functions'
import { VoteStatusText } from './VoteStatusText'

interface ProcessingVotesListProps {
  votesSubmitted: VoteSubmitDto[]
}

export const ProcessingVotesList: FC<ProcessingVotesListProps> = ({
  votesSubmitted,
}) => {
  if (!votesSubmitted || votesSubmitted.length === 0) {
    return null
  }

  return (
    <ProcessingVotesContainer>
      {votesSubmitted.map((vote, index) => {
        const { isProcessing } = getVoteStatusFlags(vote)

        return (
          <ProcessingVoteRow
            key={vote.originalTxHash || index}
            className={isProcessing ? processingAnimationCss : ''}
          >
            <Typography
              fontSize={10}
              fontWeight={700}
              color={getColorByStatus(vote.status)}
            >
              <VoteStatusText status={vote.status} />:{' '}
              {formatTon(vote.tonStake)} TON
            </Typography>
          </ProcessingVoteRow>
        )
      })}
    </ProcessingVotesContainer>
  )
}

const ProcessingVotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`
const processingAnimationCss = css`
  animation: pulse 2s ease-in-out infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`
const ProcessingVoteRow = styled.div`
  display: flex;
  align-items: center;
`
